import classNames from 'classnames';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

import type { Device } from '../../services/routes/devices';

import styles from './DeviceList.module.scss';

interface DeviceListProps {
  devices: Device[];
  selectedDeviceId: number | null;
  onDeviceSelect: (deviceId: number) => void;
}

const DeviceList: React.FC<DeviceListProps> = ({ devices, selectedDeviceId, onDeviceSelect }) => {
  return (
    <Container>
      <Row>
        <Col>
          <h2 className={styles.title}>Cписок девайсов</h2>
        </Col>
      </Row>
      <Row>
        {devices.map(device => (
          <Col key={device.id} xs={12} sm={6} md={4} lg={3}>
            <Card
              className={classNames(styles.deviceCard, {
                [styles.deviceCardSelected]: selectedDeviceId === device.id,
              })}
              onClick={() => onDeviceSelect(device.id)}
            >
              <Card.Body>
                <Card.Title>{device.name}</Card.Title>
                <Card.Text className={classNames('text-muted')}>
                  Игроков: {device.places?.length || 0}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DeviceList;
